var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48812 5.19998H11.6548M4.54367 1.75V2.65011M10.4881 1.75V2.65M10.4881 2.65H4.65479C3.68829 2.65 2.90479 3.45588 2.90479 4.44999V10.45C2.90479 11.4441 3.68829 12.25 4.65479 12.25H10.4881C11.4546 12.25 12.2381 11.4441 12.2381 10.45L12.2381 4.44999C12.2381 3.45588 11.4546 2.65 10.4881 2.65ZM6.11312 8.79999L6.98812 9.69999L9.02979 7.6",
    stroke: "#F6A723",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderScheduled);
export default __webpack_public_path__ + "static/media/calenderScheduled.55d809f43e7c47278bcc3f0ce7403d27.svg";
export { ForwardRef as ReactComponent };